import React from 'react';
import TablaPartidos from './TablaPartidos.js';
import styles from './PartidosFechaEtapa.module.css';

const PartidosFechaEtapa = (props) => {
  const fecha = props.fecha;
  const partidos = props.partidos;
  const torneo = props.torneo;

  let partidosFecha = [];
  let equiposLibres = [];
  if (fecha && partidos) {
    for (const partido of partidos) {
      if (partido.nroFecha === Number(fecha)) {
        if (partido.equipoLibre) {
          const nombreLocal =
            partido.equipoLocal && partido.equipoLocal.nombre
              ? partido.equipoLocal.nombre
              : 'Equipo desconocido';
          equiposLibres = [...equiposLibres, nombreLocal];
        } else {
          partidosFecha = [...partidosFecha, partido];
        }
      }
    }
  }

  // Agrupar partidos por zona
  const partidosPorZona = {};
  const zonasOrdenadas = [];

  partidosFecha.forEach((partido) => {
    const zona = partido.zona || null;
    if (!partidosPorZona[zona]) {
      partidosPorZona[zona] = [];
      zonasOrdenadas.push(zona);
    }
    partidosPorZona[zona].push(partido);
  });

  // Verificar si hay zonas definidas
  const hayZonas =
    zonasOrdenadas.length > 1 || (zonasOrdenadas.length === 1 && zonasOrdenadas[0] !== null);

  const obtenerTituloZona = (zona) => {
    if (!zona) return null;
    if (zona === 'X') return 'Interzonal';
    return `Zona ${zona}`;
  };

  const onPartidoElegido = (partidoElegido) => {
    props.onPartidoElegido(partidoElegido);
  };

  // Renderizar equipos libres
  const renderEquiposLibres = () => {
    if (equiposLibres.length === 0) return null;
    return (
      <div className={styles.equiposLibres}>
        {equiposLibres.map((nombre, index) => (
          <div key={`libre-${index}`} className={styles.equipoLibre}>
            Libre: {nombre}
          </div>
        ))}
      </div>
    );
  };

  return (
    <React.Fragment>
      {hayZonas ? (
        // Si hay zonas, mostrar una tabla por zona
        <div className={styles.contenedorZonas}>
          {zonasOrdenadas.map((zona) => (
            <TablaPartidos
              key={zona || 'sin-zona'}
              partidos={partidosPorZona[zona]}
              torneo={torneo}
              onPartidoElegido={onPartidoElegido}
              mostrarOrdenPartido={false}
              tituloGrupo={obtenerTituloZona(zona)}
            />
          ))}
        </div>
      ) : (
        // Si no hay zonas, mostrar una sola tabla
        <TablaPartidos
          partidos={partidosFecha}
          torneo={torneo}
          onPartidoElegido={onPartidoElegido}
          mostrarOrdenPartido={false}
        />
      )}
      {renderEquiposLibres()}
    </React.Fragment>
  );
};

export default PartidosFechaEtapa;
